<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-spreadsheet`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42.667 6C43.955 6 45 6.895 45 8v32c0 1.105-1.045 2-2.333 2H5.333C4.045 42 3 41.105 3 40V8c0-1.105 1.045-2 2.333-2h37.334zM13 31H7v7h6v-7zm28 0H17v7h24v-7zM13 21H7v6h6v-6zm28 0H17v6h24v-6zM13 10H7v7h6v-7zm28 0H17v7h24v-7z"/></svg>
</template>
<script>

export default {
  name: 'IconSpreadsheet',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
